<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>{{$helper.getWord('save')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <DataFilter :gridId="gridId" :isExport="false"></DataFilter>
        <SlickGrid
          :gridId="gridId"
          :editable="false"
          :frozenColumn="2"
          :isAutoInitData="true"
          :isModeManager="true"
          :baseUrl="baseUrl"
        />
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Staff Relationship",
  access_code: "G_MT05",
  order: 5,
  components: {},
  data() {
    return {
      gridId: "mt05",
      formData: {
        staff_name: ""
      },
      baseUrl:"/system_maintainence"
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

     grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    mode() {
      return this.grid.mode;
    },
    dataList() {
      return this.grid.data;
    }
  },
  mounted() {
  
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),

    saveButtonClicked() {
      helper.loading();
      api.request(
        this,
        "post",
        `${this.baseUrl}/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
         Parameters: {
            id: this.$route.params.id,
            dataList:this.dataList,
            mode: this.mode
          }
        },
        function(r) {
          helper.clearData(this);
          helper.findNow(this);
          helper.done();
        },
        function(r) {
          helper.done();
        },
        null
      );
    },

    cancelBtnClick() {
      this.$router.go(-1);

    }
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>